module.exports = __webpack_public_path__ + "static/media/3page_02.a47097e4.jpg";